import { Link, NavLeft } from "framework7-react";

export function NavLeftBack() {
  return (
    <NavLeft>
      <Link
        back
        icon="icon-back"
      />
    </NavLeft>
  );
}
